import React from 'react';
import './MediaQuery.css';

const MediaQuery = props  => {
  return(
  <div className={`MediaQuery-${props.size}`}>
      { props.children }
  </div>
  );
};

MediaQuery.defaultProps = {
    size: 'mobile'
}

MediaQuery.propTypes = {
    size: React.PropTypes.oneOf(['mobile', 'desktop'])
}

export default MediaQuery;



// WEBPACK FOOTER //
// ./src/components/media-query/MediaQuery.js